import React from 'react'
import { connect } from 'react-redux' 
import { Redirect } from 'react-router-dom'
import { PREFIX } from 'Lib'
import {
  setDisplayName,
  branch,
  renderComponent,
  compose
} from 'recompose'
import { getIsLoggedIn } from 'Features/auth/selectors'

const RedirectToLogin = () => <Redirect to={`${PREFIX}/login`} />
const withAuthCheck = WrappedComponent => props => (
  <WrappedComponent {...props} />
)

export default WrappedComponent => compose(
  setDisplayName('withAuthCheck'),
  connect(
    state => ({
        isLoggedIn: getIsLoggedIn(state)
    })
  ),
  branch(
    ({ isLoggedIn }) => isLoggedIn,
    withAuthCheck,
    renderComponent(RedirectToLogin)
  )
)(WrappedComponent)


// WEBPACK FOOTER //
// ./src/lib/withAuthCheck.js